/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { get as getUser } from 'js/lib/user';

import { CoachChat } from 'bundles/ai-coach-platform/components/patterns';
import { ChatEmptyState } from 'bundles/ai-coach-platform/components/patterns/chat/common';
import { firstNameFromFullName } from 'bundles/ai-course-coach/utils/nameParser';
import CourseraAiFooter from 'bundles/unified-common/components/coach-on-discovery/CourseraAiFooter';
import CourseraAiHeader from 'bundles/unified-common/components/coach-on-discovery/CourseraAiHeader';
import CourseraAiMessage from 'bundles/unified-common/components/coach-on-discovery/CourseraAiMessage';
import CourseraAiMessageLoader from 'bundles/unified-common/components/coach-on-discovery/CourseraAiMessageLoader';
import CourseraAiTemporaryStreamedMessage from 'bundles/unified-common/components/coach-on-discovery/CourseraAiTemporaryStreamedMessage';
import StyledCoachChatContainer from 'bundles/unified-common/components/coach-on-discovery/StyledCoachChatContainer';
import { useCoachState } from 'bundles/unified-common/providers/CoachStateProvider';

import _t from 'i18n!nls/xdp';

type Props = {
  headerRef: React.RefObject<HTMLSpanElement>;
};

const styles = {
  coachChat: css`
    padding: 0;

    .coach-message-client {
      display: flex;
      align-items: flex-end;
    }
  `,
};

const CoachChatContainer = ({ headerRef }: React.PropsWithChildren<Props>) => {
  const { coachOpen, setCoachOpen, contextConfig } = useCoachState();

  const { fullName: userName } = getUser();
  const userFirstName = userName ? firstNameFromFullName(userName) : null;
  const displayTitle = userFirstName ? _t('Hi, #{userFirstName}!', { userFirstName }) : _t('Hi, learner!');
  const displaySubtitle = _t('How can I help?');
  return (
    <React.Fragment>
      {coachOpen && (
        <StyledCoachChatContainer headerRef={headerRef} topOffset={64}>
          <CoachChat
            additionalStyles={styles.coachChat}
            showSettings={true}
            mode={contextConfig.config.coachModeId}
            contextConfig={contextConfig}
            onClose={() => setCoachOpen(false)}
            storeSessionId={true}
            emptyState={<ChatEmptyState title={displayTitle} subtitle={displaySubtitle} />}
            customHeader={<CourseraAiHeader onClose={() => setCoachOpen(false)} />}
            renderCustomMessage={(props) => <CourseraAiMessage {...props} />}
            renderCustomMessageLoader={(props) => <CourseraAiMessageLoader {...props} />}
            renderCustomTemporaryStreamedMessage={(props) => <CourseraAiTemporaryStreamedMessage {...props} />}
            customFooter={<CourseraAiFooter />}
            enableTextStreaming={true}
          />
        </StyledCoachChatContainer>
      )}
    </React.Fragment>
  );
};

export default CoachChatContainer;
